import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useParams } from 'react-router-dom';

const FormEditSubSubCategory = () => {
  document.title = "Edit Sub Sub Category | Uma Classes";
  const { id } = useParams(); // Get SubSubCategory ID from URL parameters

  const [formData, setFormData] = useState({
    name: "",
    category: "",
    subcategory: "",
  });

  const [categories, setCategories] = useState([]); // State to store categories fetched from API
  const [subcategories, setSubcategories] = useState([]); // State to store subcategories
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [errorMessage, setErrorMessage] = useState(""); // State for error message

  // Fetch categories, subcategories, and SubSubCategory details on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        // Fetch categories
        const categoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-category', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCategories(categoriesResponse); // Assuming the response contains an array of categories

        // Fetch subcategories
        const subcategoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-subcategory', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSubcategories(subcategoriesResponse); // Assuming the response contains an array of subcategories

        // Fetch SubSubCategory details
        const subSubCategoryResponse = await axios.get(`https://uma.aasmo.in/api/admin/getbyid-subsubcategory/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Set SubSubCategory data to form state
        const subSubCategoryData = subSubCategoryResponse; // Get the correct data
        setFormData({
          name: subSubCategoryData.name,
          category: subSubCategoryData.subcategory.category._id, // Set category ID
          subcategory: subSubCategoryData.subcategory._id, // Set subcategory ID
        });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.put(`https://uma.aasmo.in/api/admin/update-subsubcategory/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      });
      setSuccessMessage("Sub SubCategory Edited successfully");
      setErrorMessage(""); // Clear any previous error messages
    } catch (error) {
      console.error("Error Editing Sub SubCategory:", error);
      setSuccessMessage(""); // Clear any previous success messages
      setErrorMessage("Error Editing Sub SubCategory");
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Optional: Add a loading spinner or message
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="SubSubCategory" breadcrumbItem="Edit" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-3 col-form-label">
                        Sub Sub Category Name
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="category" className="col-md-2 col-form-label">
                        Category
                      </label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="category"
                          name="category"
                          value={formData.category}
                          onChange={handleChange}
                        >
                          <option value="">Select Category</option>
                          {categories.map(category => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="subcategory" className="col-md-2 col-form-label">
                        SubCategory
                      </label>
                      <div className="col-md-12">
                        <select

                        
                          className="form-control"
                          id="subcategory"
                          name="subcategory"
                          value={formData.subcategory}
                          onChange={handleChange}
                        >
                          <option value="">Select SubCategory</option>
                          {subcategories
                            .filter(subcat => subcat.category._id === formData.category)
                            .map(subcategory => (
                              <option key={subcategory._id} value={subcategory._id}>
                                {subcategory.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </Row>

                    {successMessage && <Alert color="success">{successMessage}</Alert>}
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    <button type="submit" className="btn btn-primary">Edit</button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormEditSubSubCategory;
